import React from 'react';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  checkboxRequiredSchema,
  checkboxUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */ export default {
  uiSchema: {
    ...titleUI('Section VI: Authorization, certification, and signature'),
    'ui:description': (
      <div>
        <VaAlert status="info" className="vads-u-margin-top--3" uswds visible>
          <h2 slot="headline" className="vads-u-font-weight--bold">
            What to expect:
          </h2>
          <div className="vads-u-margin--0">
            <ul style={{ marginBottom: 0 }}>
              <li>Authorize the release of your application</li>
              <li>Certify the information you have included is true</li>
              <li>Review important legal disclaimers</li>
              <li>Review all your information</li>
              <li>Electronically sign and submit</li>
              <li>Takes about 2-5 minutes</li>
            </ul>
          </div>
        </VaAlert>
        <div className="vads-u-margin-top--5">
          <h2 className="vads-u-font-size--h3" style={{ marginTop: 0 }}>
            Acknowledgements
          </h2>
          <p>
            Read and agree to the following authorization and certification
            statements, and review the legal information presented.
          </p>
        </div>
      </div>
    ),
    'ui:order': [
      'authorizationRelease',
      'certificationStatements',
      'serviceConnectedStatements',
      'view:sectionSixPenaltyAlert',
    ],
    'view:sectionSixPenaltyAlert': {
      'ui:field': 'ViewField',
      'ui:description': (
        <VaAlert
          status="warning"
          className="vads-u-margin-top--3"
          uswds
          visible
        >
          <h2 slot="headline" className="vads-u-font-weight--bold">
            Penalty
          </h2>
          <p className="vads-u-margin--0">
            The law provides severe penalties which include fine or imprisonment
            or both for the willful submission of any statement or evidence of a
            material fact, knowing it to be false or for the fraudulent
            acceptance of any payment to which you are not entitled.
          </p>
        </VaAlert>
      ),
    },

    authorizationRelease: checkboxUI({
      title:
        'I have read and understand the authorization for release of information.',
      description: (
        <div>
          <p className="vads-u-font-weight--bold vads-u-margin-bottom--1 vads-u-margin-top--0">
            Authorization for release of information
          </p>
          <p className="vads-u-margin-top--0">
            I authorize the person or entity, including but not limited to any
            organization, service provider, employer, or Government agency, to
            give the Department of Veterans Affairs any information about me
            except protected health information, and I waive any privilege which
            makes the information confidential.
          </p>
        </div>
      ),
      classNames:
        'vads-u-background-color--gray-lightest vads-u-padding--4 vads-u-margin-bottom--4',
      marginTop: null,
      required: () => true,
      errorMessages: {
        enum: 'You must acknowledge the authorization to continue.',
        required: 'You must acknowledge the authorization to continue.',
      },
      label:
        'I have read and understand the authorization for release of information',
    }),
    certificationStatements: checkboxUI({
      title: 'I have read and understand the certification of statements.',
      description: (
        <div>
          <p className="vads-u-font-weight--bold vads-u-margin-bottom--1 vads-u-margin-top--0">
            Certification of statements
          </p>
          <p className="vads-u-margin-top--0">
            I CERTIFY THAT as a result of my service-connected disabilities, I
            am unable to secure or follow any substantially gainful occupation
            and that the statements in this application are true and complete to
            the best of my knowledge and belief, I understand that these
            statements will be considered in determining my eligibility for VA
            benefits based on unemployability because of service-connected
            disability
          </p>
        </div>
      ),
      classNames:
        'vads-u-background-color--gray-lightest vads-u-padding--4 vads-u-margin-bottom--4',
      marginTop: null,
      required: () => true,
      errorMessages: {
        enum: 'You must acknowledge the certification to continue.',
        required: 'You must acknowledge the certification to continue.',
      },
      label: 'I have read and understand the certification of statements',
    }),
    serviceConnectedStatements: checkboxUI({
      title:
        'I have read and understand the information about total disability benefits.',
      description: (
        <div>
          <p className="vads-u-font-weight--bold vads-u-margin-bottom--1 vads-u-margin-top--0">
            Important information about total disability benefits
          </p>
          <p className="vads-u-margin-top--0">
            I understand that if I am granted service-connected total disability
            benefits based on my unemployability, I must immediately inform VA
            if I return to work. I also understand that total disability
            benefits paid to me after I begin work may be considered an
            overpayment requiring repayment to VA.
          </p>
        </div>
      ),
      classNames:
        'vads-u-background-color--gray-lightest vads-u-padding--4 vads-u-margin-bottom--4',
      marginTop: null,
      required: () => true,
      errorMessages: {
        enum: 'You must acknowledge the information to continue.',
        required: 'You must acknowledge the information to continue.',
      },
      label:
        'I have read and understand the information about total disability benefits',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      authorizationRelease: checkboxRequiredSchema,
      certificationStatements: checkboxRequiredSchema,
      serviceConnectedStatements: checkboxRequiredSchema,
      'view:sectionSixPenaltyAlert': {
        type: 'object',
        properties: {},
      },
    },
    required: [
      'authorizationRelease',
      'certificationStatements',
      'serviceConnectedStatements',
    ],
  },
};
